import { render } from "./Menu.vue?vue&type=template&id=1b5406c6&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=1b5406c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b5406c6"

export default script